<template>
   <div id="left-sidebar" class="sidebar dark-active">
      <a href="javascript:void(0);" class="menu_toggle"><i class="fa fa-angle-left"></i></a>
      <button type="button" class="btn-toggle-offcanvas br50 btn mr-2 mt-2 float-right "><i class="far fa-times"></i></button>
      <div class="navbar-brand imgLateralBar">
         <router-link to="/paginaInicial"><img src="@/assets/images/logo-256x256.png" alt="Mooli Logo" class="img-fluid logo header"><span class="font-16 font-weight-bold">ACECE</span></router-link>
      </div>
      <div class="sidebar-scroll">
         <nav id="left-sidebar-nav" class="sidebar-nav">
            <ul id="main-menu" class="metismenu animation-li-delay">
               <li :class="$route.path == '/paginaInicial' ? 'active' : ''">
                  <router-link to="/paginaInicial"><i class="fas fa-home font-14" ></i> <span class="font-14">Página inicial</span></router-link>
               </li>

               <li class="header text-secondary mt-3 font-13">Controles</li>
               
               <li :class="$route.path == '/cadastros' ? 'active' : ''">
                  <router-link to="/cadastros"><i class="fas fa-users"></i> <span class="font-14">Cadastros</span></router-link>
               </li>
               <li :class="$route.path == '/agenda' ? 'active' : ''">
                  <router-link to="/agenda"><i class="fas fa-book"></i> <span class="font-14">Agenda</span></router-link>
               </li>
               <li :class="$route.path == '/adicionar' ? 'active' : ''" v-if="dadosEscola.id != 0">
                  <router-link to="/adicionar"><i class="fas fa-file-signature"></i> <span class="font-14">Cadastrar</span></router-link>
               </li>
               <li :class="$route.path == '/relatorio' ? 'active' : ''">
                  <router-link to="/relatorio"><i class="fas fa-chart-bar"></i> <span class="font-14">Relatório</span></router-link>
               </li>

               <!-- Apenas admin -->
               <li class="header text-secondary mt-3 font-13" v-if="dadosUsuario.usuarioAdmin == true">Admin</li>

               <li :class="$route.path == '/logins' ? 'active' : ''" v-if="dadosUsuario.usuarioAdmin == true">
                  <router-link to="/logins"><i class="fas fa-key"></i> <span class="font-14">Login</span></router-link>
               </li>

               <li :class="$route.path == '/editarEscola' ? 'active' : ''" v-if="dadosUsuario.usuarioAdmin == true">
                  <router-link to="/editarEscola"><i class="fas fa-graduation-cap"></i> <span class="font-14">Escolas</span></router-link>
               </li>
            </ul>
         </nav>     
      </div>
   </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'MenuLateral',
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         dadosEscola: state => state.dadosEscola,
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      deslogar : function () {
			this.$store.dispatch('deslogar')
      },
      abrirEditarSenha : function () {
         this.$emit('abrirEditarSenha')
      },
      abrirEditarFoto : function () {
         this.$emit('abrirEditarFoto')
      }
   },
   mounted() {
      console.log(JSON.stringify(this.dadosUsuario))
   }
}

</script>

<style scoped>

</style>